import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=ad45a962&scoped=true&"
import script from "./Offers.vue?vue&type=script&lang=js&"
export * from "./Offers.vue?vue&type=script&lang=js&"
import style0 from "./Offers.vue?vue&type=style&index=0&id=ad45a962&prod&scoped=true&lang=css&"
import style1 from "./Offers.vue?vue&type=style&index=1&id=ad45a962&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad45a962",
  null
  
)

export default component.exports